<template>
  <div>
    <div class="fix-wrapper">
      <breadcrumb
        :crumbs="[$t('menu.purchases'), $t('text.create')]"
      ></breadcrumb>
      <div class="container">
        <el-form
          ref="formObjForm"
          :model="formObj"
          label-width="100px"
          size="small"
        >
          <div class="pd20">
            <fieldset>
              <legend>
                {{ $t("text.baseInfo") }}
                <el-checkbox v-model="formObj.hurry" class="float-right">{{
                  $t("order.hurry")
                }}</el-checkbox>
              </legend>

              <el-row :gutter="20">
                <el-col :span="8">
                  <el-form-item
                    :label="$t('purchase.serialNo')"
                    :prop="'serialNo'"
                    :rules="[
                      {
                        required: true,
                        validator: validateSerialNo,
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-input
                      size="small"
                      v-model.trim="formObj.serialNo"
                      :placeholder="$t('prompt.alphabetNumberLine')"
                      clearable
                    >
                      <template slot="append">
                        <svg-icon
                          icon-class="serialNo"
                          style="font-size: 24px"
                          @click="clickSetSerialNo"
                        ></svg-icon>
                      </template>
                    </el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('menu.suppliers')"
                    :prop="'supplierId'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('menu.suppliers')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-select
                      size="small"
                      v-model="formObj.supplierId"
                      filterable
                      clearable
                      @change="selectSupplier"
                    >
                      <el-option
                        v-for="supplier in suppliers"
                        :key="supplier.id"
                        :label="supplier.name"
                        :value="supplier.id"
                      />
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="8">
                  <el-form-item
                    :label="$t('text.handOverAt')"
                    :prop="'handOverAt'"
                    :rules="[
                      {
                        required: true,
                        message: $t('rules.required', [$t('text.handOverAt')]),
                        trigger: 'blur',
                      },
                    ]"
                  >
                    <el-date-picker
                      size="small"
                      v-model="formObj.handOverAt"
                      type="date"
                      style="width: 100%"
                      :picker-options="pickerTodayAfterTime"
                    />
                  </el-form-item>
                </el-col>
              </el-row>
            </fieldset>
            <fieldset>
              <legend>
                {{ $t("order.productInfo") }}
              </legend>
              <div
                class="flex flex-between mgb10"
                v-for="(item, index) in formObj.items"
                :key="index"
              >
                <div class="mgr10">
                  <thumbnail :images="item.images" />
                </div>
                <div class="flex-grow">
                  <el-row :gutter="20">
                    <el-col :span="19">
                      <el-row :gutter="20" class="mgb10">
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="item.serialNo"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('order.serialNo')])
                            "
                            @blur="blurOrderSerialNo(index)"
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="item.productNo"
                            :fetch-suggestions="querySearchProductNo"
                            :data-index="index"
                            :trigger-on-focus="false"
                            style="width: 100%"
                            :placeholder="
                              $t('rules.mustFillSimple', [
                                $t('product.productNo'),
                              ])
                            "
                            @focus="getFoucs(index)"
                            @select="handleSelectProductNo(index)"
                          >
                            <template slot-scope="{ item }">
                              <div class="name">{{ item.productNo }}</div>
                              <span class="addr">{{
                                item.productNoAlias
                              }}</span>
                            </template>
                          </el-autocomplete>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="item.color"
                            :fetch-suggestions="querySearchColor"
                            :placeholder="$t('product.color')"
                            style="width: 100%"
                            @focus="getFoucs(index)"
                            @select="handleSelectColor(index)"
                          ></el-autocomplete>
                        </el-col>
                        <el-col :span="6">
                          <el-autocomplete
                            size="small"
                            v-model.trim="item.size"
                            :fetch-suggestions="querySearchSize"
                            :placeholder="$t('product.size')"
                            style="width: 100%"
                            @focus="getFoucs(index)"
                            @select="handleSelectSize(index)"
                          ></el-autocomplete>
                        </el-col>
                      </el-row>
                      <el-row :gutter="20">
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="item.quantity"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('text.quantity')])
                            "
                          ></el-input>
                        </el-col>
                        <el-col :span="6">
                          <el-input
                            size="small"
                            v-model.trim="item.price"
                            :placeholder="
                              $t('rules.mustFillSimple', [$t('purchase.price')])
                            "
                          ></el-input>
                        </el-col>

                        <el-col :span="6" class="font10">
                          <template
                            v-if="item.categoryName != null"
                            class="mgr5 mgt5"
                            >{{ item.categoryName }}</template
                          >
                          <template
                            v-if="item._productBrand != null"
                            class="mgr5 mgt5"
                            >/{{ item._productBrand }}</template
                          >
                        </el-col>
                        <el-col
                          :span="6"
                          class="font10 mgt5"
                          v-if="
                            item.price != null &&
                            item.price != '' &&
                            item.quantity != null &&
                            item.quantity != ''
                          "
                        >
                          {{ $t("order.subtotal") }}:
                          {{ item.price * item.quantity }}
                        </el-col>
                      </el-row>
                    </el-col>
                    <el-col :span="5">
                      <el-input
                        type="textarea"
                        :rows="3"
                        :placeholder="$t('text.remark')"
                        v-model="item.remark"
                      ></el-input>
                    </el-col>
                  </el-row>
                </div>
                <div class="remove-order">
                  <el-button
                    type="text"
                    size="small"
                    @click="remove(index)"
                    v-if="index != 0"
                    >{{ $t("text.remove") }}</el-button
                  >
                </div>
              </div>
              <div class="center">
                <el-button
                  v-if="formObj.items.length < 10"
                  type="info"
                  @click="addMore"
                  plain
                  round
                  >{{ $t("action.addProduct") }}</el-button
                >
                <span v-else class="orange">
                  {{ $t("prompt.addMorePrompt") }}
                </span>
              </div>
            </fieldset>
          </div>
          <div class="form-footer">
            <el-button
              type="primary"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit('submit')"
              >{{ $t("text.submit") }}</el-button
            >
            <el-button
              type="success"
              size="medium"
              plain
              :loading="saveDoing"
              @click="saveSubmit('submitAndPlace')"
              >{{ $t("text.submit") }}并{{ $t("action.place") }}</el-button
            >
            <back-button />
          </div>
        </el-form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import Vue from "vue";
import ls from "store2";
import Util from "@/utils/index.js";
import { page } from "@/utils/mixins.js";
import UploadSinglePicture from "@/components/UploadSinglePicture/index.vue";
import BackButton from "@/components/BackButton/index.vue";

import Size from "@/api/size.js";
import Color from "@/api/color.js";
import Product from "@/api/product.js";
import Purchase from "@/api/purchase.js";
import Supplier from "@/api/supplier.js";
import Category from "@/api/category.js";

function build() {
  return {
    serialNo: null,
    supplierId: null,
    supplierName: null,
    supplierTenantId: null,
    customerName: null,
    customerPhone: null,
    customerCountry: null,
    customerProvince: null,
    customerCity: null,
    customerAddress: null,
    hurry: false,
    handOverAt: null,

    productNo: null,
    categoryId: null,
    categoryName: null,
    color: null,
    colorImage: null,
    size: null,
    quantity: null,
    unit: null,
    price: null,
    images: null,
    remark: null,
    specJson: null,
    enclosure: null,
    craftwork: null,
    attachment: null,
    currency: "CNY",
    replaceDeliver: false,
    workflowState: null,
    type: null,
    _productNoColors: null,
    _productNoSizes: null,
    _productIntroduction: null,
    _productLabels: null,
    _productBrand: null,
    _oldSizeExplain: null,
    _productId: null,
    _productSuppliers: [],
  };
}
export default {
  mixins: [page],
  components: {
    UploadSinglePicture,
    BackButton,
  },
  data() {
    var validateSerialNo = (rule, value, callback) => {
      const self = this;
      if (value === null || value === "") {
        callback(
          new Error(this.$t("rules.required", [this.$t("purchase.serialNo")]))
        );
        return;
      }
      if (!Util.regexAlphabetNumberLine(value)) {
        callback(new Error(this.$t("prompt.regexAlphabetNumberLine")));
        return;
      }
      Purchase.findBySerialNo({ serialNo: value }).then(function (res) {
        if (res.data.code === 200) {
          callback(
            new Error(self.$t("rules.exist", [self.$t("purchase.serialNo")]))
          );
        } else {
          callback();
        }
      });
    };

    return {
      validateSerialNo: validateSerialNo,
      suppliers: [],
      sizes: [],
      colors: [],
      categories: [],

      pickerTodayAfterTime: {
        disabledDate(time) {
          return time.getTime() < Date.now() - 8.64e7;
        },
      },
      formObj: {
        serialNo: null,
        hurry: false,
        supplierId: null,
        handOverAt: null,
        items: [build(), build(), build()],
      },
      saveDoing: false,
      productNoColors: [],
      productNoSizes: [],
      products: [],
    };
  },
  mounted() {},
  created() {
    const self = this;

    axios
      .all([
        Supplier.findByTenantId(),
        Size.findByTenantId(),
        Color.findByTenantId(),
        Category.findByTenantId(),
      ])
      .then(
        axios.spread(function (suppliers, sizes, colors, categories) {
          if (suppliers.status === 200) {
            self.suppliers = suppliers.data;
          } else {
            self.sysError();
          }
          if (sizes.status === 200) {
            self.sizes = sizes.data;
          } else {
            self.sysError();
          }
          if (colors.status === 200) {
            self.colors = colors.data;
          } else {
            self.sysError();
          }
          if (categories.status === 200) {
            self.categories = categories.data;
          } else {
            self.sysError();
          }
        })
      );
  },

  methods: {
    clickSetSerialNo() {
      this.formObj.serialNo = Util.serialNo();
      for (let i = 0; i < this.formObj.items.length; i++) {
        this.formObj.items[i].serialNo = this.formObj.serialNo + "-" + (i + 1);
      }
    },
    selectSupplier() {},
    //
    addMore() {
      const bulidNew = JSON.parse(JSON.stringify(build()));
      if (this.formObj.serialNo != null && this.formObj.serialNo != "") {
        bulidNew.serialNo =
          this.formObj.serialNo + "-" + (this.formObj.items.length + 1);
      }
      this.formObj.items.push(bulidNew);
    },
    remove(idx) {
      this.formObj.items.splice(idx, 1);
    },
    //
    blurOrderSerialNo(index) {
      const self = this;
      if (
        self.formObj.items[index].serialNo === null ||
        self.formObj.items[index].serialNo === ""
      ) {
        self.$message({
          message: self.$t("rules.required", [self.$t("purchase.serialNo")]),
          type: "warning",
        });
        return;
      }
      if (!Util.regexAlphabetNumberLine(self.formObj.items[index].serialNo)) {
        self.$message({
          message: self.$t("prompt.regexAlphabetNumberLine"),
          type: "warning",
        });
        return;
      }
      // 前台本地过滤
      const iis = self.formObj.items.filter(function (ii) {
        return ii.serialNo === self.items[index].serialNo;
      });
      if (iis.length > 1) {
        self.$message({
          message: self.$t("rules.exist", [self.$t("order.serialNo")]),
          type: "warning",
        });
        self.formObj.items[index].serialNo = null;
        return;
      }
      Purchase.findBySerialNo({
        serialNo: self.formObj.items[index].serialNo,
      }).then(function (res) {
        if (res.data.code === 200) {
          self.$message({
            message: self.$t("rules.exist", [self.$t("purchase.serialNo")]),
            type: "warning",
          });
          self.formObj.items[index].serialNo = null;
        } else {
          self.sysError();
        }
      });
    },
    getFoucs(index) {
      this.currentIndex = index;
    },
    // 货号
    querySearchProductNo(queryString, cb) {
      const self = this;
      if (queryString == null || queryString.length < 1) {
        return;
      }
      Product.vagueFindByProductNo({ productNo: queryString }).then(function (
        res
      ) {
        const ps = res.data;
        ps.forEach((p) => (p.value = p.productNo));
        self.products = ps;
        cb(self.products);
      });
    },
    handleSelectProductNo(idx) {
      const self = this;
      const item = self.products.find(
        (p) => p.productNo === self.formObj.items[idx].productNo
      );
      self.formObj.items[idx]._productId = item.id;
      self.formObj.items[idx].productNo = item.productNo;
      self.formObj.items[idx].categoryId = item.categoryId;
      self.formObj.items[idx].categoryName = item.categoryName;
      self.selsectCategory(idx);
      self.formObj.items[idx].color = null;
      self.formObj.items[idx].colorImage = null;
      self.formObj.items[idx].size = null;
      self.formObj.items[idx].images = item.images;
      self.formObj.items[idx].unit = item.unit;
      self.formObj.items[idx].craftwork = item.craftwork;
      self.formObj.items[idx].remark =
        (self.formObj.items[idx].remark || "") + (item.introduction || "");
      self.formObj.items[idx]._productNoColors = item.colors;
      self.formObj.items[idx]._productNoSizes = item.sizes;
      self.formObj.items[idx]._productIntroduction = item.introduction;
      self.formObj.items[idx]._productLabels = item.productLabels;
      self.formObj.items[idx]._productBrand = item.brand;
      self.getProductSuppliers(idx);
    },
    //
    selsectCategory(idx) {
      const self = this;
      // console.log("===selsectCategory:", idx, self.orders[idx].categoryId);
      // console.log("=====", self.formObj.items[idx].categoryId);
      if (self.formObj.items[idx].categoryId == "") {
        self.formObj.items[idx].categoryId = null;
      }
      self.formObj.items[idx]._categorySizes = [];
      if (self.formObj.items[idx].categoryId != null) {
        const selsectCategoryObj = self.categories.find(
          (c) => c.id === self.formObj.items[idx].categoryId
        );
        if (
          selsectCategoryObj &&
          selsectCategoryObj.sizes != null &&
          selsectCategoryObj.sizes.length !== 0
        ) {
          self.formObj.items[idx]._categorySizes = selsectCategoryObj.sizes;
        }
      }
    },
    getProductSuppliers(idx) {
      const self = this;
      if (
        self.formObj.supplierId != null &&
        self.formObj.items[idx]._productId != null
      ) {
        Product.productSuppliersfindById(
          self.formObj.items[idx]._productId
        ).then(function (res) {
          if (res.status === 200) {
            self.formObj.items[idx]._productSuppliers = res.data;
            self.computePrice(idx);
          } else {
            self.sysError();
          }
        });
      }
    },

    // 颜色
    querySearchColor(queryString, cb) {
      const self = this;
      const colors =
        self.formObj.items[self.currentIndex]._productNoColors.length !== 0
          ? self.formObj.items[self.currentIndex]._productNoColors.map((pc) => {
              return { value: pc };
            })
          : self.colors.map((c) => {
              return { value: c.name };
            });
      if (queryString == null) {
        cb(colors);
      } else {
        cb(colors.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectColor(idx) {
      this.formObj.items[idx].color = Util.jyTrim(
        this.formObj.items[idx].color
      );
    },
    // 规格
    querySearchSize(queryString, cb) {
      const self = this;
      let sizes = [];
      if (self.formObj.items[self.currentIndex]._productNoSizes.length !== 0) {
        sizes = self.formObj.items[self.currentIndex]._productNoSizes.map(
          (pc) => {
            return { value: pc };
          }
        );
      } else {
        if (self.formObj.items[self.currentIndex]._categorySizes.length !== 0) {
          sizes = self.formObj.items[self.currentIndex]._categorySizes.map(
            (c) => {
              return { value: c.name, explain: c.explain };
            }
          );
        } else {
          sizes = self.sizes.map((c) => {
            return { value: c.name, explain: c.explain };
          });
        }
      }
      if (queryString == null) {
        cb(sizes);
      } else {
        cb(sizes.filter((c) => c.value.indexOf(queryString) !== -1));
      }
    },
    handleSelectSize(idx) {
      const self = this;
      self.formObj.items[idx].size = Util.jyTrim(self.formObj.items[idx].size);
      self.computeRemark(idx);
      self.computePrice(idx);
    },
    computeRemark(idx) {
      const self = this;
      const sizeObj = self.sizes.find(
        (s) => s.name === self.formObj.items[idx].size
      );
      // 替换已经有的尺码说明
      if (
        self.formObj.items[idx].remark != null &&
        self.formObj.items[idx]._oldSizeExplain != null
      ) {
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          ";【" + self.formObj.items[idx]._oldSizeExplain + "】",
          ""
        );
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          "<br/>【" + self.formObj.items[idx]._oldSizeExplain + "】",
          ""
        );
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          "【" + self.formObj.items[idx]._oldSizeExplain + "】",
          ""
        );
        self.formObj.items[idx].remark = self.formObj.items[idx].remark.replace(
          self.formObj.items[idx]._oldSizeExplain,
          ""
        );
      }
      // 加入新的尺码说明
      if (sizeObj != null && sizeObj.explain != null && sizeObj.explain != "") {
        if (
          self.formObj.items[idx].remark !== null &&
          self.formObj.items[idx].remark != ""
        ) {
          self.formObj.items[idx].remark =
            self.formObj.items[idx].remark + ";【" + sizeObj.explain + "】";
        } else {
          self.formObj.items[idx].remark = "【" + sizeObj.explain + "】";
        }
        self.formObj.items[idx]._oldSizeExplain = sizeObj.explain;
      }
    },
    computePrice(idx) {
      const self = this;
      // 产品 供应商规格价格
      if (
        self.formObj.supplierId != null &&
        self.formObj.items[idx]._productSuppliers.length != 0
      ) {
        const productSupplierObj = self.formObj.items[
          idx
        ]._productSuppliers.find(
          (p) => p.supplierId == self.formObj.supplierId
        );
        if (
          productSupplierObj.supplierSizePrices.find(
            (sp) => sp.size == self.formObj.items[idx].size
          ) != null
        ) {
          self.formObj.items[
            idx
          ].price = productSupplierObj.supplierSizePrices.find(
            (sp) => sp.size == self.formObj.items[idx].size
          ).price;
          return;
        }
        self.formObj.items[idx].price = productSupplierObj.price;
        return;
      }

      // 产品采购价
      self.formObj.items[idx].price = null;
    },

    saveSubmit(type) {
      let self = this;
      self.$refs.formObjForm.validate((valid) => {
        if (valid) {
          const items = JSON.parse(JSON.stringify(self.formObj.items)).filter(
            (o) =>
              o.serialNo !== null &&
              o.serialNo !== "" &&
              o.productNo !== null &&
              o.productNo !== "" &&
              o.quantity !== null &&
              o.quantity !== "" &&
              o.price !== null &&
              o.price !== ""
          );
          if (items.length === 0) {
            self.$message.error(this.$t("prompt.atLeastOneValidDataFillIn"));
            return;
          }
          const serialNos = items.map((o) => o.serialNo);
          const serialNosSet = [...new Set(serialNos)];
          if (serialNos.length !== serialNosSet.length) {
            self.$message({
              message: self.$t("prompt.existSamePurchaseSerialNoLocal"),
              type: "warning",
            });
            return;
          }
          Purchase.findBySerialNos(serialNosSet).then(function (res) {
            if (res.status == 200) {
              if (res.data.length !== 0) {
                const text =
                  "有以下" + res.data.length + "条采购单号已存在:<br/><br/>";
                let detail = "";
                for (const data of res.data) {
                  detail =
                    detail +
                    "<div style='margin-bottom: 2px'>" +
                    data +
                    "<div>";
                }
                self.$message({
                  dangerouslyUseHTMLString: true,
                  message: text + detail,
                  type: "warning",
                });
                return;
              }
              for (const i of items) {
                if (!Util.regexPrice(i.price)) {
                  self.$message({
                    message: self.$t("rules.regex", [
                      self.$t("purchase.price"),
                    ]),
                    type: "warning",
                  });
                  return;
                }
                if (!Util.regexQuantity(i.quantity) || i.quantity === "0") {
                  self.$message({
                    message: self.$t("rules.regex", [self.$t("text.quantity")]),
                    type: "warning",
                  });
                  return;
                }

                i.supplierId = self.formObj.supplierId;
                i.supplierName = self.suppliers.find(
                  (s) => s.id === self.formObj.supplierId
                ).name;
                i.supplierTenantId = self.suppliers.find(
                  (s) => s.id === self.formObj.supplierId
                ).sourceTenantId;
                i.customerName = self.Permit.currentUser().name;
                i.customerPhone = self.Permit.currentUser().phone;
                i.customerCountry = self.Permit.currentUser().country;
                i.customerProvince = self.Permit.currentUser().province;
                i.customerCity = self.Permit.currentUser().city;
                i.customerAddress = self.Permit.currentUser().address;
                i.handOverAt = Util.formatDate(self.formObj.handOverAt);
                i.hurry = self.formObj.hurry;
                i.color = Util.jyTrim(i.color);
                i.size = Util.jyTrim(i.size);

                if (type === "submit") {
                  i.workflowState = "newly";
                } else {
                  i.workflowState = "gived";
                }
              }
              self.saveDoing = true;
              Purchase.insertBatch(items).then(function (res) {
                self.saveDoing = false;
                if (res.status === 200) {
                  self.$message({
                    message: self.$t("prompt.saveSuccess"),
                    type: "success",
                  });
                  self.$router.push({
                    name: "pmsPurchases",
                  });
                  self.$eventHub.$emit("purchaseInsertBatch");
                } else {
                  self.sysError();
                }
              });
            } else {
              self.sysError();
            }
          });
        } else {
          return false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.name {
  text-overflow: ellipsis;
  overflow: hidden;
}
.addr {
  font-size: 12px;
  color: #b4b4b4;
}
</style>